var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "1. Money",
    id: "_1._Money"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,9.18V8a3,3,0,0,0-3-3H22.16a18.57,18.57,0,0,1-5.85-1A20.43,20.43,0,0,0,9.84,3H5A3,3,0,0,0,2,6V7.18A3,3,0,0,0,0,10V24a3,3,0,0,0,3,3H9.84a18.41,18.41,0,0,1,5.84.95A20.45,20.45,0,0,0,22.16,29H29a3,3,0,0,0,3-3V12A3,3,0,0,0,30,9.18ZM5,5H9.84a18.57,18.57,0,0,1,5.85,1,20.43,20.43,0,0,0,6.47,1H27a1,1,0,0,1,1,1V9H22.16a18.41,18.41,0,0,1-5.84-.95A20.45,20.45,0,0,0,9.84,7H4V6A1,1,0,0,1,5,5ZM30,26a1,1,0,0,1-1,1H22.16a18.41,18.41,0,0,1-5.84-.95A20.45,20.45,0,0,0,9.84,25H3a1,1,0,0,1-1-1V10A1,1,0,0,1,3,9H9.84a18.41,18.41,0,0,1,5.84.95A20.45,20.45,0,0,0,22.16,11H29a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,15h2a1,1,0,0,0,0-2H17a1,1,0,0,0-2,0v.18A3,3,0,0,0,16,19a1,1,0,0,1,0,2H14a1,1,0,0,0,0,2h1a1,1,0,0,0,2,0v-.18A3,3,0,0,0,16,17a1,1,0,0,1,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,16H6a1,1,0,0,0,0,2H8a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,18H24a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyDecrease);
export default __webpack_public_path__ + "static/media/moneyDecrease.75b8ae4709f39a2da7232ec03acdbfdd.svg";
export { ForwardRef as ReactComponent };